// extracted by mini-css-extract-plugin
export default {"Courses":"Courses_Courses__UamSg","card":"Courses_card__6Mj7k","card_info":"Courses_card_info__4bUgY","card_buttons":"Courses_card_buttons__s3-VO"};